import { service } from "../utils/request";

export function addCarclass(data) {
  return service({
    url: "manage/car.car_type/add",
    method: "post",
    data: data
  });
}
export function editCarclass(data) {
  return service({
    url: "manage/car.car_type/edit",
    method: "post",
    data: data
  });
}
export function CarTypelist(data) {
  return service({
    url: "manage/car.car_type/index",
    method: "get",
    params: data
  });
}
export function CarRZlist(data) {
  return service({
    url: "manage/car.car_certification/index",
    method: "get",
    params: data
  });
}
export function CarTypedetail(data) {
  return service({
    url: "manage/car.car_type/detail",
    method: "get",
    params: data
  });
}
export function Carstatus(data) {
  return service({
    url: "manage/car.car_type/disable",
    method: "post",
    data: data
  });
}
export function CarTypedel(data) {
  return service({
    url: "manage/car.car_type/del",
    method: "post",
    data: data
  });
}
export function RZdetail(data) {
  return service({
    url: "manage/car.car_certification/detail",
    method: "get",
    params: data
  });
}
export function RZaudit(data) {
  return service({
    url: "manage/car.car_certification/audit",
    method: "post",
    data: data
  });
}
